import React from 'react'
import { StyleSheet, Text, View } from 'react-native'
import {
  BG_STYLES,
  Button,
  BUTTON_TYPE,
  COMMON_STYLES,
  SIZE,
  TEXT_STYLES,
  TYPOGRAPHY,
  VARIANTS_STYLES,
} from '@dehaat/dds'
import { ROUTES } from 'app/routes/types'
import RequestSuccess from 'app/icons/RequestSuccess'
import { navigationRef } from 'app/utils/RootNavigation'
import { CommonActions } from '@react-navigation/native'
import { useRoute } from '@react-navigation/native'

export const handleSuccessReset = () => {
  const state = navigationRef.getRootState()
  const routeNames = state.routes.map(route => route.name)
  const isFromDashboardFlow = routeNames.includes(ROUTES.DASHBOARD)

  if (isFromDashboardFlow) {
    // Navigate to Dashboard first (this clears the stack)
    navigationRef.dispatch(CommonActions.navigate(ROUTES.DASHBOARD))

    // Then navigate to PriceRequest
    setTimeout(() => {
      navigationRef.dispatch(
        CommonActions.navigate(ROUTES.PRICE_REQUEST, { resetFilters: true }),
      )
    }, 10)
  } else {
    // Navigate directly to PriceRequest
    navigationRef.dispatch(
      CommonActions.navigate(ROUTES.PRICE_REQUEST, { resetFilters: true }),
    )
  }
}

export const handleDemoSuccessReset = () => {
  navigationRef.dispatch(
    CommonActions.reset({
      index: 1,
      routes: [
        {
          name: ROUTES.DASHBOARD,
        },
        {
          name: ROUTES.DEMO_MATERIAL_REQUEST,
          params: { resetFilters: true },
        },
      ],
    }),
  )
}

const RequestSuccessScreen = () => {
  const route: any = useRoute()
  const flow = route.params?.flow || 'PRICE_CHANGE'
  const isDemoFlow = flow === 'DEMO_MATERIAL'

  const onViewRequest = () => {
    if (isDemoFlow) {
      handleDemoSuccessReset()
      return
    }
    handleSuccessReset()
  }

  return (
    <View style={styles.container}>
      <View style={styles.content}>
        <RequestSuccess />
        <View style={styles.titleWrap}>
          <Text style={styles.titleTop}>
            {isDemoFlow ? 'Demo Material Request' : 'Price Change Request'}
          </Text>
          <Text style={styles.titleBottom}>Submitted!</Text>
        </View>
      </View>
      <View style={styles.footer}>
        <Button
          buttonStyle={COMMON_STYLES.mb1}
          onClick={onViewRequest}
          type={BUTTON_TYPE.SECONDARY}
          text="View Request"
          size={SIZE.large}
        />
      </View>
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    ...BG_STYLES.bgSuccess100,
    ...COMMON_STYLES.flex1,
  },
  content: {
    ...COMMON_STYLES.flex1,
    ...COMMON_STYLES.justifyCenter,
    ...COMMON_STYLES.alignItemsCenter,
    ...COMMON_STYLES.ph1,
  },
  footer: {
    paddingHorizontal: 24,
    paddingBottom: 24,
    paddingTop: 12,
  },
  titleWrap: {
    ...COMMON_STYLES.mt1,
    ...COMMON_STYLES.alignItemsCenter,
  },
  titleTop: {
    ...TEXT_STYLES.textNeutral00,
    ...TYPOGRAPHY.HEADING3,
    ...VARIANTS_STYLES.MEDIUM,
    ...COMMON_STYLES.textCenter,
  },
  titleBottom: {
    ...TEXT_STYLES.textNeutral00,
    ...TYPOGRAPHY.HEADING2,
    ...VARIANTS_STYLES.BOLD,
    ...COMMON_STYLES.textCenter,
  },
})

export default RequestSuccessScreen
